let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4uuAu")).then(() => parcelRequire('5ge8P'));